(function () {
  function initCharCounters(root) {
    root.querySelectorAll('[data-validea-cf7-counter]').forEach(function (counter) {
      var field = counter.closest('.validea-cf7__field');
      if (!field) {
        return;
      }

      var textarea = field.querySelector('textarea');
      if (!textarea) {
        return;
      }

      var max = parseInt(textarea.getAttribute('maxlength'), 10) || 600;

      function update() {
        counter.textContent =
          textarea.value.length + ' of ' + max + ' max characters';
      }

      textarea.addEventListener('input', update);
      update();
    });
  }

  function init(scope) {
    initCharCounters(scope || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('wpcf7mailsent', function (event) {
    if (event.target) {
      init(event.target);
    }
  });

  document.addEventListener('wpcf7invalid', function (event) {
    if (event.target) {
      init(event.target);
    }
  });
})();
